// fork of https://www.youtube.com/watch?v=uWeK30vg35c&ab_channel=MichaelCouch
// yes youtube, turtles don't like react so this is a mess, but it's not a rug

// BRONDER drop claim app

import './App.css';
import Bro from'./Bro';
// import Approve from './approve.js'
function App() {

  return (
    <div className="App">
    {/* <WalletCard/> */}
    <Bro/>
    </div>
  );
}

export default App;
